import upSvg from '../../svg/up.svg'
import "./index.less"
export default ({name})=>{


    return <div style={{  display:"flex", justifyContent:"center"}}>
    <div className="cny">
        <div >{name}</div>
        <div style={{transform:"rotate(270deg)", marginLeft:"7px"}}><img src={upSvg} style={{width:"0.3rem", height:"0.25rem"}} /></div>
    </div>

</div>
}